import { render } from "./company-settings.vue?vue&type=template&id=14697dbe&scoped=true"
import script from "./company-settings.vue?vue&type=script&lang=js"
export * from "./company-settings.vue?vue&type=script&lang=js"

import "./company-settings.vue?vue&type=style&index=0&id=14697dbe&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14697dbe"]])

export default __exports__